export const affordabilityEndPoints = {
    affordabilityMedSourceMpinTable: '/affordability/medication-sourcing-mpin-details',
    affordabilityMPINTable: '/affordability/mpin-details',
    affordabilityDDPMPINTable: '/affordability/ddp-mpin-details',
    affordabilityImpactByTaxID:'/affordability/impact-by-taxid',
    radiologyMPINTable: '/affordability/radio-cardio-pa-details',
    affordabilitySOSDetailsPage: '/affordability/site-of-service-details',
    affordablityHRLDetailsPage: 'affordability/hospital-reference-lab-details',
    HRLDateFilter: 'date-filter-source/HRL'
  };